import { SqlBuilderDataDto } from '@core/services/dto';

export class SqlBuilderDataModel {
  branchName: string;
  entityId: number;
  fullName: string;
  memberNumber: number;
  memberStatus: string;
  AccountNumber: string;
  AccountBalance: string;
  ProductDesc: string;

  constructor(dto: SqlBuilderDataDto) {
    this.branchName = dto.BranchName;
    this.entityId = dto.EntityId;
    this.fullName = dto.FullName;
    this.memberNumber = dto.MemberNumber;
    this.memberStatus = dto.MemberStatus;
    this.AccountNumber = dto.AccountNumber;
    this.ProductDesc = dto.ProductDesc;
    this.AccountBalance = dto.AccountBalance;
  }
}
